module.exports = __webpack_public_path__ + "media/images/new_home/icon-1-d0af99a3c395bfeada17ad76327266f5.png";